import React from 'react';

import {PreviousMeetingsWidgetTotalScores} from "./previous-meetings-widget.total-scores";
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {observer} from "mobx-react";
import styles from "../styles/previous-meetings-widget.module.scss";
import classNames from "classnames";
import {PreviousMeetingsWidgetCompetitorDetails} from "./previous-meetings-widget.competitor-details";

export class PreviousMeetingsWidgetHeaderProps extends PreviousMeetingsWidgetProps {
}

export const PreviousMeetingsWidgetHeader = observer(({controller}: PreviousMeetingsWidgetHeaderProps) => {
  const {state} = controller;
  const {emptyPreviousMeetingsMessage, homeCompetitor, awayCompetitor, isEmptyState, device:{isSmallView}} = state;


  return (
    <div className={classNames(styles.header_container, {[styles.small_view]: isSmallView})}>
      <PreviousMeetingsWidgetCompetitorDetails controller={controller} isHomeTeam
                                               competitorLinkModel={homeCompetitor.linkModel}/>
      {
        isEmptyState ?
          <div className={classNames(styles.empty_state)}>{emptyPreviousMeetingsMessage}</div>
          :
          <PreviousMeetingsWidgetTotalScores controller={controller}/>
      }
      <PreviousMeetingsWidgetCompetitorDetails controller={controller} competitorLinkModel={awayCompetitor.linkModel}/>
    </div>
  )
});
